import styled from "styled-components";

export const DeviceMetricsWrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    grid-gap: 30px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 300px;

    padding-right: 20px;
    box-sizing: border-box;
`;

export const ChartWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const ChartHeader = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    padding-left: 30px;
`;

export const ChartName = styled.div`
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 2px;
    padding-right: 10px;
    padding-bottom: 5px;
`;

export const ChartHeaderColorBlock = styled.div`
    width: 3px;
    height: 25px;
    margin-bottom: 5px;
`;

export const ChartCurrentValue = styled.div`
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 2px;
    padding-left: 10px;
`;

export const ChartInfo = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 20px;
`;

export const ChartLatestMetricTime = styled.div`
    font-size: 11px;
    color: #555555;
`;

export const ChartUnit = styled.div`
    font-size: 11px;
    color: #555555;
`;

export const EChartsWrapper = styled.div`
    flex: 1 1 auto;
`;

